import { render, staticRenderFns } from "./detail-manager.vue?vue&type=template&id=14949037&"
import script from "./detail-manager.vue?vue&type=script&lang=js&"
export * from "./detail-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports